import {Card} from 'antd';
import {getErrorCodesTranslations} from '../../constants/getErrorCodesTranslations';
import React, { Fragment } from 'react';
import { MARGIN_MD } from '../../styles/constants';
import ReportWarningList from './ReportWarningList';

function getTitle(t) {
  return t('middlewares.feedback.error.title');
}

function getTranslatedError(t, errorCode) {

    const translatedErrorCode = getErrorCodesTranslations(t)[errorCode];

    return translatedErrorCode !== undefined
      ? translatedErrorCode
      : errorCode;
}

export function getExceptionError(t, exception) {
  if (exception && exception.errorCode) {
    return getTranslatedError(t, exception.errorCode);
  }
  return null;
}

export function getExceptionReport(exception) {
  if (exception && exception.report) {
    return exception.report;
  }
  return null;
}

export const ReportError = ({
                            t,
                            exception
                        }) => {


    return (                           

      (exception && exception.report && Object.keys(exception.report).length > 0) ?
        (<Fragment>
          {getExceptionError(t, exception)}
          <div style={{ marginTop: MARGIN_MD }}>
            <ReportWarningList t={t} warnings={exception.report} />
          </div>
        </Fragment>
        ) :
        (<Card
            type="inner"
            title={getTitle(t)}
            bodyStyle={{
              maxHeight: 160,
              overflow: 'auto'
            }}
        >
            <div>
            {getExceptionError(t, exception)}
            </div>   
        </Card>)
    );
}
